import React from "react";
import Image from "components/image";
import Link from "components/link";
import { useCustomer } from "hooks/useStore";
import { ReactComponent as Heart } from "assets/svgs/fi-rs-heart.svg";
import { ReactComponent as GiftBox } from "svgs/fi-rs-gift.svg";
import { ReactComponent as Star } from "svgs/star.svg";
import { ReactComponent as HistoryIcon } from "svgs/history.svg";
import clsx from "clsx/lite";

const BannerImage = ({ data }) => {
	const { isAuthenticated, pointsApproved, pointsPending } =
		useCustomer(["isAuthenticated", "pointsApproved", "pointsPending"]);

	if (data.showOnlyPoints) {
		return (
			<div className="p-10 bg-black flex justify-center">
				{isAuthenticated ? (
					<p className="text-white">You have {pointsApproved} points ({pointsPending} pending)</p>
				) : (
					<p className="text-xl">
						Join Loyalty Points and get rewarded while you shop.
						You&apos;ll get 400 points  for signing up. What are you waiting for?
					</p>
				)}
			</div>
		);
	}
	else {
		return (
			<div className="w-full relative">
				<div className="*:w-full *:aspect-video *:min-h-128 *:object-cover *:object-center *:max-h-144">
					<Image className={data.mobileImage ? "!hidden md:!block" : ""} image={data.image} />
					{data.mobileImage && <Image className="md:!hidden" image={data.mobileImage} />}
				</div>
				<div className={
					clsx("justify-center text-center absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center gap-10",
						"text-white bg-gradient-to-r from-[rgba(0,0,0,0.7)] via-[rgba(94,94,94,0.00)] to-[rgba(0,0,0,0.7)]")}>
					<div className={clsx(
						"md:pt-60 px-5 flex flex-col gap-10 items-center",
						isAuthenticated ? "pt-10" : "md:pb-20 py-10"
					)}>
						<div className="flex flex-col max-w-3xl gap-4">
							<h1 className="md:text-7xl">{isAuthenticated ? data.title : data.guestTitle}</h1>
							{isAuthenticated
								? (<p className="text-3xl">You have {pointsApproved} points ({pointsPending} pending)</p>)
								: (<p className="text-xl">
									Join Loyalty Points and get rewarded while you shop.
									You&apos;ll get 400 points  for signing up. What are you waiting for?
								</p>)
							}
						</div>
						{isAuthenticated
							? (
								<nav
									className={
										clsx("lion-header__nav lion-integrated-page--authenticated",
											"flex flex-wrap justify-center")}>
									<a href="#rewards" className="flex gap-2 items-center"><Heart className="fill-black size-5" />
										Your rewards
									</a>
									<a href="#earn" className="flex gap-2 items-center">
										<Star className="fill-black size-5" />Earn points
									</a>
									<a href="#redeem"
										className="flex gap-2 items-center">
										<GiftBox className="fill-black size-5" />Rewards
									</a>
									<a href="#history"
										className="flex gap-2 items-center">
										<HistoryIcon className="fill-black size-5" />History</a>
								</nav>
							)
							: (
								<div className="flex flex-col md:flex-row gap-6">
									<Link to="/account/register" className="btn-quaternary px-14 py-5 w-72">Join Now</Link>
									<Link to="/account/login" className="btn-secondary px-14 py-5 w-72 text-black">Log In</Link>
								</div>
							)}
					</div>
				</div>
			</div>
		);
	}
};

export default BannerImage;